"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Set = Set;

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _reduceRight = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce-right"));

var _react = _interopRequireDefault(require("react"));

var _links = require("./links");

var _location = require("./location");

var _privateContext = require("./private-context");

var _router = require("./router");

var _routerContext = require("./router-context");

var _util = require("./util");

function Set(props) {
  var _context;

  const {
    wrap,
    children,
    ...rest
  } = props;
  const routerState = (0, _routerContext.useRouterState)();
  const location = (0, _location.useLocation)();
  const {
    loading
  } = routerState.useAuth();
  const {
    isPrivate,
    unauthorized,
    unauthenticated
  } = (0, _privateContext.usePrivate)();
  const wrappers = (0, _isArray.default)(wrap) ? wrap : [wrap]; // slap the wrappers in an array

  const flatChildArray = (0, _util.flattenAll)(children);
  const routes = (0, _filter.default)(_context = (0, _filter.default)(flatChildArray).call(flatChildArray, _router.isRoute)).call(_context, r => typeof r.props.path !== 'undefined');

  for (const route of routes) {
    const path = route.props.path;
    const {
      match
    } = (0, _util.matchPath)(path, location.pathname, routerState.paramTypes);

    if (match) {
      if (isPrivate && unauthorized()) {
        if (loading) {
          var _route$props, _route$props$whileLoa;

          return ((_route$props = route.props) === null || _route$props === void 0 ? void 0 : (_route$props$whileLoa = _route$props.whileLoading) === null || _route$props$whileLoa === void 0 ? void 0 : _route$props$whileLoa.call(_route$props)) || null;
        } else {
          var _context2;

          const currentLocation = global.location.pathname + encodeURIComponent(global.location.search);
          const unauthenticatedRoute = (0, _filter.default)(_context2 = routerState.routes).call(_context2, ({
            name
          }) => unauthenticated === name)[0];
          return /*#__PURE__*/_react.default.createElement(_links.Redirect, {
            to: `${unauthenticatedRoute.path}?redirectTo=${currentLocation}`
          });
        }
      } // Expand and nest the wrapped elements.


      return (0, _reduceRight.default)(wrappers).call(wrappers, (acc, wrapper) => {
        return /*#__PURE__*/_react.default.createElement(wrapper, { ...rest,
          children: acc ? acc : children
        });
      }, undefined) || null;
    }
  } // No match, no render.


  return null;
}